import React from "react";
import { Button, Form, Input } from "antd";

/**
 * Name / email / phone form used when adding a contact (user mode and event mode).
 * Calls onSubmit({ name, email, phone_number }).
 */
const ContactForm = ({ onSubmit, loading, submitLabel = "Save contact", extra = null }) => (
	<Form layout="vertical" onFinish={onSubmit} requiredMark={false} size="large">
		<Form.Item label="Full name" name="name" rules={[{ required: true, message: "Enter the contact's name" }]}>
			<Input placeholder="e.g. Jane Doe" />
		</Form.Item>
		<Form.Item
			label="Email"
			name="email"
			rules={[{ required: true, type: "email", message: "Enter a valid email address" }]}
		>
			<Input placeholder="jane@example.com" />
		</Form.Item>
		<Form.Item
			label="Phone number (optional)"
			name="phone_number"
			rules={[{ pattern: /^[0-9]{7,15}$/, message: "Digits only, 7 to 15 characters" }]}
		>
			<Input placeholder="3065551234" />
		</Form.Item>
		<div style={{ display: "flex", gap: 12, flexWrap: "wrap", alignItems: "center" }}>
			<Button type="primary" htmlType="submit" loading={loading}>
				{submitLabel}
			</Button>
			{extra}
		</div>
	</Form>
);

export default ContactForm;
